<template>
  <main-container class="model-convert-result-list-container" title="データ変換結果一覧" :subTitle="modelName">
    <template slot="main-content">
      <div style="flex-grow: 1; height: 100%;">
        <h3 v-if="convertResults != null && convertResults.length <= 0">変換結果がありません</h3>
        <h3 v-if="convertResults != null && convertResults.length > 0">全件数：{{convertResults.length | number_format}}</h3>
        <fixed-header-table v-if="convertResults != null && convertResults.length > 0" :fixed="true">
          <tr slot="header">
            <th>キー
              <el-popover placement="bottom-start">
                <el-autocomplete :fetch-suggestions="fetchSuggestionsKey" placeholder="IDまたはアップロードファイル名"
                                 v-model="filterKey" clearable="true" style="width: 400px;"
                                 @change="onChangeFilter"></el-autocomplete>
                <font-awesome-icon slot="reference" class="icon filter" icon="filter" style="margin-left: 16px;"
                                   :class="{ 'has-filter': filterKey }"/>
              </el-popover>
            </th>
            <th>変換方法
              <el-popover placement="bottom-start">
                <el-autocomplete :fetch-suggestions="fetchSuggestionsConverter" placeholder="変換方法"
                                 v-model="filterConverter" clearable="true" style="width: 400px;"
                                 @change="onChangeFilter"></el-autocomplete>
                <font-awesome-icon slot="reference" class="icon filter" icon="filter" style="margin-left: 16px;"
                                   :class="{ 'has-filter': filterConverter}"/>
              </el-popover>
            </th>
            <th>変換日時
              <el-popover placement="bottom-start">
                <div style="display: flex; flex-direction: row; align-items: center;">
                  <el-date-picker v-model="filterFrom" type="date" placeholder="開始日" format="yyyy/MM/dd"
                                  value-format="yyyyMMdd" @change="onChangeFilter"></el-date-picker>
                  <span style="margin: 0 16px;">～</span>
                  <el-date-picker v-model="filterTo" type="date" placeholder="終了日" format="yyyy/MM/dd"
                                  value-format="yyyyMMdd" @change="onChangeFilter"></el-date-picker>
                </div>
                <font-awesome-icon slot="reference" class="icon filter" icon="filter" style="margin-left: 16px;"
                                   :class="{ 'has-filter': (filterFrom || filterTo) }"/>
              </el-popover>
            </th>
            <th>データ件数</th>
            <th style="flex-grow: 0; min-width: 166px; max-width: 166px;"></th>
          </tr>
          <tr v-for="result in filteredConvertResults()">
            <td>{{result.key}}</td>
            <td>{{result.converterName}}</td>
            <td>{{result.updatedAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD HH:mm')}}</td>
            <td>
              <template v-if="result.statusCode === 0">{{result.count | number_format}}</template>
              <template v-else-if="result.statusCode === 3">変換中</template>
              <template v-else>変換に失敗しました</template>
            </td>
            <td style="flex-grow: 0; justify-content: center; min-width: 166px; max-width: 166px;">
              <el-button v-if="result.statusCode === 0" style="flex-grow: 1;" type="primary"
                         @click="onClickDownload(result.resultFile)">ダウンロード
              </el-button>
              <template v-else-if="result.statusCode === 3">-</template>
              <el-button v-else style="flex-grow: 1;" type="danger" @click="onConfirmedError(result.taskId)">確認
              </el-button>
            </td>
          </tr>
        </fixed-header-table>
      </div>
    </template>

    <template slot="main-footer">
      <el-button type="default" @click="changeLocation('data-convert')">戻る</el-button>
    </template>
  </main-container>
</template>

<script lang="js">
import BaseView from '../../base'
import ConvertResultDialogCmp from '../../../components/data-convert/dialogs/convert-result.vue'
import WebApiClient from '../../../api/web'
import CommonUtil from '../../../utils/common'
import DateUtil from '../../../utils/date'
import MessageBox from '../../../utils/message-box'

export default {
  name: 'ModelConvertView',
  mixins: [BaseView],
  components: {
    'convert-result-dialog': ConvertResultDialogCmp
  },
  props: {
    modelId: ''
  },
  data () {
    return {
      convertResults: null,
      keyList: [],
      converterList: [],
      filterKey: '',
      filterConverter: '',
      filterFrom: '',
      filterTo: ''
    }
  },
  created () {
    this.loadModelConvertResultList()
  },
  methods: {
    fetchSuggestionsKey (queryString, callback) {
      const results = CommonUtil.isNotEmpty(queryString) ? this.keyList.filter(
        key => key.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) : this.keyList
      callback(results)
    },
    fetchSuggestionsConverter (queryString, callback) {
      const results = CommonUtil.isNotEmpty(queryString) ? this.converterList.filter(
        key => key.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) : this.converterList
      callback(results)
    },
    loadModelConvertResultList () {
      WebApiClient.getConvertResultList(this, null).then((response) => {
        this.convertResults = response.data.result.converts

        const existKeys = []
        for (const convertResult of this.convertResults) {
          if (existKeys.indexOf(convertResult.key) >= 0) continue
          existKeys.push(convertResult.key)
          this.keyList.push({
            value: convertResult.key
          })
        }

        const existConverters = []
        for (const convertResult of this.convertResults) {
          if (existConverters.indexOf(convertResult.converterName) >= 0) continue
          existConverters.push(convertResult.converterName)
          this.converterList.push({
            value: convertResult.converterName
          })
        }

        this.$forceUpdate()
      })
    },
    filteredConvertResults () {
      if (CommonUtil.isEmpty(
        this.filterKey.concat(this.filterConverter).concat(this.filterFrom).concat(this.filterTo))) {
        return this.convertResults
      }

      const filterFrom = CommonUtil.isNotEmpty(this.filterFrom) ? DateUtil.parse(this.filterFrom, 'YYYYMMDD') : null
      const filterTo = CommonUtil.isNotEmpty(this.filterTo) ? DateUtil.parse(this.filterTo, 'YYYYMMDD') : null

      return this.convertResults.filter(convertResult => {
        if (convertResult.statusCode !== 0) return true

        const convertDate = DateUtil.parse(convertResult.updatedAt, 'YYYYMMDD')

        if (CommonUtil.isNotEmpty(this.filterKey)) {
          if (convertResult.key.toLowerCase().indexOf(this.filterKey.toLowerCase()) < 0) return false
        }
        if (CommonUtil.isNotEmpty(this.filterConverter)) {
          if (convertResult.converterName.toLowerCase().indexOf(this.filterConverter.toLowerCase()) < 0) return false
        }
        if (CommonUtil.isNotNull(filterFrom)) {
          if (!filterFrom.isSameOrBefore(convertDate)) return false
        }
        if (CommonUtil.isNotNull(filterTo)) {
          if (!filterTo.isSameOrAfter(convertDate)) return false
        }

        return true
      })
    },
    onChangeFilter () {
      this.$forceUpdate()
    },
    onClickDownload (downloadUrl) {
      window.location.href = downloadUrl
    },
    onConfirmedError (taskId) {
      MessageBox.confirm(this, `データを変換出来ませんでした。<br>データは削除されます。<br>原因不明の場合はお問合せください。`, {
        dangerouslyUseHTMLString: true
      }).then(() => {
        return this.confirmedError(taskId)
      }).catch(() => {})
    },
    confirmedError (taskId) {
      return WebApiClient.deleteTask(this, taskId).then(() => {
        this.convertResults = this.convertResults.filter(
          result => CommonUtil.isEmpty(result.taskId) || result.taskId !== taskId)
        this.$forceUpdate()
      })
    }
  }
}

</script>

<style scoped>
  .model-convert-result-list-container >>> .main-content {
    display: flex;
    flex-direction: column;
    padding: 24px;
  }

  .icon.filter {
    cursor: pointer;
  }

  .icon.filter:hover {
    opacity: 0.7;
  }

  .icon.filter.has-filter {
    color: #2456d4;
  }
</style>



// WEBPACK FOOTER //
// src/views/data/convert/result-list.vue